/**
 * Chart Keyfigure Comparison Variable File
 * ----------------------------------------
 * handles variables shared among different classes
 */

/**
 * Selectors
 */
const chartSelectSelecotr = '.js-chart-select-toggle';
const chartAreaSelector = '.js-chart-area';
export const chartSwitchSelector = 'input[name="chart-switches"]';
const viewSwitchSelector = 'input[name="display-type"]';
const lineViewID = '#lines';
const colViewID = '#bars';
const tableViewID = '#table';
const printBtnSelector = '.js-print-chart';
const exportPNGBtnSelector = '.js-export-png';
const swappedLegendsSelector = '.js-swap-legends';
const indexedValsSelector = '.js-indexed-values';
const chartTitleSelector = '#chartName';
export const chartContainerID = "container";
export const chartLegendSelector = ".legend";
export const chartCatContainerSelector = ".categories";


/**
 * Number Formatting
 */
export let decimalPoint = "."; // default value: "."
export let numericSymbols = null; // default value: ["k", "M", "G", "T", "P", "E"]
export let thousandsSep = " "; // default value: \u0020

/**
 * Don't change these
 */
import URLParamHandler from "../Classes/URLParamHandler";
let currentURL = window.location.href;
export let URLHandle = new URLParamHandler(currentURL);
let language = document.querySelector("html").getAttribute("lang");
export const lang = language.substring(0, 2);

if(lang == 'fr'){
  decimalPoint = ',';
}

/**
 * Don't change these
 */
export const chartArea = document.querySelector(chartAreaSelector);
export const chartSelects = [...document.querySelectorAll(chartSelectSelecotr)];
export const chartSwitches = [...document.querySelectorAll(chartSwitchSelector)];
export const viewSwitches = [...document.querySelectorAll(viewSwitchSelector)];
export const printBtn = [...document.querySelectorAll(printBtnSelector)];
export const exportPNGBtn = [...document.querySelectorAll(exportPNGBtnSelector)];
export const swappedLegendsBtn = [...document.querySelectorAll(swappedLegendsSelector)];
export const indexedValsBtn = [...document.querySelectorAll(indexedValsSelector)];
export const catsArray = [...document.querySelectorAll(chartCatContainerSelector)];
export const legendsArray = [...document.querySelectorAll(chartLegendSelector)];
export const chartTitle = document.querySelector(chartTitleSelector);
export let currentChart = document.querySelector(`${chartSwitchSelector}:checked`).id;

// URL Parameters
export const URLParams = {
  chart: URLHandle.getParameter('chart') ? URLHandle.getParameter('chart') : currentChart,
  isLines: URLHandle.getParameter('isLines') ? URLHandle.getParameter('isLines') : document.querySelector(lineViewID).checked,
  isCols: URLHandle.getParameter('isCols') ? URLHandle.getParameter('isCols') : document.querySelector(colViewID).checked,
  isTable: URLHandle.getParameter('isTable') ? URLHandle.getParameter('isTable') : document.querySelector(tableViewID).checked,
  inactiveSeries: URLHandle.getParameter('inactiveSeries') ? URLHandle.getParameter('inactiveSeries') : '',
  inactiveCats: URLHandle.getParameter('inactiveCats') ? URLHandle.getParameter('inactiveCats') : '',
  swappedLegends: URLHandle.getParameter('swappedLegends') ? URLHandle.getParameter('swappedLegends') : false,
  indexedVals: URLHandle.getParameter('indexedVals') ? URLHandle.getParameter('indexedVals') : false,
};

// filled through Classes
export let currentHighchart;
export let csvChartData;
export let csvChartCSVConfigArray;
export let csvChartSeriesArray;
export let csvChartCatArray;
export let csvSwappedChartSeriesArray;
export let csvSwappedChartCatArray;
export let csvSwappedInactiveCats
export let currentChartyAxisTitle;
export let currentCategoriesArray;
export let currentSeriesArray;
export let currentInactiveSeriesArray;
export let currentInactiveCatsArray;

export let currentChartName;

export let chartRenderCounter;
export let swapAllowed = true;

/**
 * Utility Functions
 * @param {*} paramsObj
 */
export function updateURLParams(paramsObj) {
  for (let key in paramsObj) {
    if (paramsObj.hasOwnProperty(key)) {
      let val = paramsObj[key];
      URLHandle.setParameter(key, val);
    }
  }
}
